import { render, staticRenderFns } from "./ConfirmPasswordSuccess.vue?vue&type=template&id=07d3a4ee&scoped=true&"
import script from "./ConfirmPasswordSuccess.vue?vue&type=script&lang=js&"
export * from "./ConfirmPasswordSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d3a4ee",
  null
  
)

export default component.exports